export interface IMissedRexm {
    id: number,
    recipientCenterId: number,
    recipientCenterAlias: string,
    donorCenterAlias: string,
    donorAlias: string,
    daysPending: number,
    isFullyConfident: boolean,
    hasExm: boolean,
    isRejected: boolean,
    hasValidResponse: boolean,
    failureReason: string
}